// ADD API URLS BELOW
export const API_URLS = {
    ARTICLE_LIST: '/umbraco/api/listing/articles',
    SEARCH_RESULTS_LIST: '/umbraco/api/searchapi/search',
};
